export default __webpack_public_path__ + "static/media/GM.fe12ed0a.png";